import { MessageThreadCriteria } from '../../../domain/message/model/message-thread-criteria';

export namespace MessageActions {
  const prefix = '[Message]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(readonly criteria: MessageThreadCriteria) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page`;

    constructor() {}
  }

  export class ArchiveThread {
    static readonly type = `${prefix} Archive thread`;

    constructor(readonly caseId: string) {}
  }

  export class InvalidateCache {
    static readonly type = `${prefix} Invalidate cache`;

    constructor() {}
  }
}
